import { inject } from "@angular/core";
import { UserSettingsQuery } from "@timeghost/web-api";
import { isUserInGroup } from "../permission";

export const useAbsencesForUser = () => {
	const userSettingsQuery = inject(UserSettingsQuery);
	return (absence: any, formGroup: any) => {
		const user = userSettingsQuery.getValue();
		const employee = formGroup.user ? formGroup.user.id : formGroup.value.employee;
		const userId = typeof employee === "string" ? employee : employee?.id;
		if (absence.enabled === false) {
			return false;
		}
		if (absence.visibleForUsers?.length || absence.visibleForGroups?.length) {
			if (absence.visibleForUsers?.includes(userId)) {
				return true;
			}
			// check if user is in group
			if (absence.visibleForGroups?.find((groupId: string) => isUserInGroup(userId, groupId, user))) {
				return true;
			}
			return false;
		}

		return true;
	};
};
